import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AuthContext = createContext(undefined);
const mockUser = {
    name: 'Test Admin',
    email: 'admin@finavia.fi',
    landlordId: 'finavia-001',
    landlordName: 'Finavia',
};
export const AuthProvider = ({ children, }) => {
    const logout = () => {
        // TODO: Implement MSAL logout
        console.log('Logout called');
    };
    const value = {
        user: mockUser,
        isAuthenticated: true,
        isLoading: false,
        logout,
    };
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
};
